"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameResultLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../../");

var _excluded = ["moment"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GameResultLabel = function GameResultLabel(_ref) {
  var moment = _ref.moment,
      props = _objectWithoutProperties(_ref, _excluded);

  // Get home & away teams and scores
  var awayTeam = moment === null || moment === void 0 ? void 0 : moment.away_team;
  var homeTeam = moment === null || moment === void 0 ? void 0 : moment.home_team;
  var scoreString = "";
  var timeAgo = "";
  var gameResult = "";
  var awayTeamTitle = ""; // score string and game results

  if (awayTeam && homeTeam) {
    gameResult = (0, _.gameResultAsString)(homeTeam, awayTeam);

    if (awayTeam.score && homeTeam.score) {
      scoreString = "".concat(awayTeam.score, ":").concat(homeTeam.score);
    }

    if (awayTeam.title) {
      awayTeamTitle = awayTeam.title;
    }
  } // time ago in words


  if (moment) {
    timeAgo = (0, _.capitalizeFirstLetter)((0, _.formatUTCTimestampAsTimeAgo)(moment.start_time));
  } // Construct the detail string


  var details;

  if ((moment === null || moment === void 0 ? void 0 : moment.type) === "CustomUpload") {
    details = "Uploaded ".concat(timeAgo);
  } else if (moment) {
    details = "".concat(timeAgo, " in a ").concat(scoreString, " ").concat(gameResult, " ").concat(awayTeamTitle);
  } else {
    details = "--";
  }

  return /*#__PURE__*/_react.default.createElement(_.Label, props, details);
};

exports.GameResultLabel = GameResultLabel;